import { type InAppMessageDto } from '../../graphql/generated/autogenerated'

export const isActionBanner = (o: any): boolean =>
    o.type === 'BANNER' &&
    typeof o.callToActionText === 'string' &&
    typeof o.callToActionUrl === 'string' &&
    typeof o.page === 'string' &&
    typeof o.body === 'string'

export const isImageBanner = (o: any): boolean =>
    o.type === 'IMAGE_BANNER' &&
    o.image &&
    typeof o.image.url === 'string' &&
    typeof o.image.alternativeText === 'string' &&
    typeof o.page === 'string'

export const isValidBanner = (o: any): boolean => {
    switch (o.type) {
        case 'BANNER':
            return isActionBanner(o)
        case 'IMAGE_BANNER':
            return isImageBanner(o)
        default:
            return false
    }
}

type BannerStackProps = { banners: InAppMessageDto[] }
type BannerStackReturn = {
    topBanner: InAppMessageDto | null
    allBanners: InAppMessageDto[]
}

export const useBannerStack = ({
    banners
}: BannerStackProps): BannerStackReturn => {
    if (!banners?.length) return { topBanner: null, allBanners: [] }

    const validBanners = banners
        .filter(isValidBanner)
        .filter(({ page }) =>
            window.location.pathname.toLowerCase().includes(page.toLowerCase())
        )

    return {
        topBanner: validBanners[0],
        allBanners: validBanners
    }
}
